import { API_HOST, getHttpPostOptions, getHttpGetOptions, getHttpPutOptions } from '../../utils/api-util';

const getEndpoint = () => `${API_HOST}/accountability-template`;
const getSpecificEndpoint = (externalReference) => `${getEndpoint()}/${externalReference}`;
const getAttendanceEndpoint = () => `${getEndpoint()}/attendance`;

export const getCreateAccountabilityTemplateRequest = (AccountabilityTemplate) => [
  getEndpoint(),
  getHttpPostOptions(AccountabilityTemplate)
];

export const getViewAccountabilityTemplateRequest = (externalReference) => [
  getSpecificEndpoint(externalReference),
  getHttpGetOptions()
];

export const getUpdateAccountabilityTemplateRequest = (accountabilityTemplate) => [
  getEndpoint(),
  getHttpPutOptions(accountabilityTemplate)
];

export const getGenerateAccountabilityTemplateSessionRequest = (sessionTemplate) => [
  getAttendanceEndpoint(),
  getHttpPostOptions(sessionTemplate)
];
